// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

( function( $ ) {
$.noConflict();

$.fn.extend({
  setequal: function( ){
  //var defaults = { findclass: '' };
  //var o = $.extend(defaults, options);

  //var c = o.findclass;
  // Get an array of all element heights
  var elementHeights = $(this).map(function() {
  return $(this).height();
  }).get();

  // Math.max takes a variable number of arguments
  // `apply` is equivalent to passing each height as an argument
  var maxHeight = Math.max.apply(null, elementHeights);

  $(this).height(maxHeight);

  return this;
  }
});

// AOS.init({disable: 'mobile'});

$( ".menu-trigger" ).click(function(e) {
  e.preventDefault();
  $(this).stop().toggleClass('triggered');
  $('header').stop().toggleClass('mobile-header');
  $('.site-menu-area').stop().slideToggle(200);
  // $('header').stop().toggleClass('menu-open');
  $('body').stop().toggleClass('unscroll');
});

$( ".learn-more-btn" ).click(function(e) {
  e.preventDefault();
  $(this).stop().toggleClass('triggered');
  $(this).siblings().stop().slideToggle();
});

var logoSlider = new Swiper(".slider-logo", {
  // centeredSlides:true,
  loop:true,
  speed:5000,
  centeredSlides: true,
  centeredSlidesBounds: true,
  slidesPerView:7,
  spaceBetween: 40,
  autoplay: {
    delay: 1,
    pauseOnMouseEnter: true,
    disableOnInteraction: false,
    waitForTransition: true,
    stopOnLastSlide: false,
  },
  breakpoints: {
    320: {
      slidesPerView:3.3,
    },
    767: {
      slidesPerView:5,
      spaceBetween: 30,
    },
    1400: {
      slidesPerView:6,
      spaceBetween: 30,
    },
    1500: {
      slidesPerView:7,
      spaceBetween: 40,
    },
  },
});

var jobSlider = new Swiper(".job-slider", {
  loop:true,
  slidesPerView:4,
  spaceBetween: 30,
  breakpoints: {
    320: {
      slidesPerView:1,
    },
    767: {
      slidesPerView:2,
    },
    991: {
      slidesPerView:3,
    },
    1400: {
      slidesPerView:4,
    },
  },
  pagination: {
    el: '.job-pagination',
    clickable: true,
  },
});

var resourcesSlider = new Swiper(".resources-slider", {
  loop:true,
  slidesPerView:3,
  spaceBetween: 30,
  breakpoints: {
    320: {
      slidesPerView:1,
    },
    767: {
      slidesPerView:2,
    },
    991: {
      slidesPerView:3,
    },
    1400: {
      slidesPerView:3,
    },
  },
  pagination: {
    el: '.resource-pagination',
    clickable: true,
  },
});

var testimonialSlider = new Swiper(".testimonial-slider", {
  loop:true,
  slidesPerView:1,
  spaceBetween: 40,
  pagination: {
    el: '.review-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.review-next',
    prevEl: '.review-prev',
  },
});

var scroll = $(window).scrollTop();
if (scroll >= 60) {
    $('header').addClass("scrolled");
} else {
    $('header').removeClass("scrolled");
}

/**
 * Script On Document Ready
 */
 $(document).on('scroll', function() {
    var scroll = $(window).scrollTop();
    if (scroll >= 60) {
        $('header').addClass("scrolled");
    } else {
        $('header').removeClass("scrolled");
    }
});

/**
 * Script On Load
 */
$( window ).load( function() {
   $('.slider-news .item h4').setequal();
   $('.slider-news .item .text-cnt').setequal();

} );

/**
 * Script On Resize
 */
$(window).on('resize', function(){
    $('.slider-news .item h4').css('height','auto');
    $('.slider-news .item h4').setequal();
    $('.slider-news .item .text-cnt').css('height','auto');
    $('.slider-news .item .text-cnt').setequal();
    if ($(window).width() >= 1200) {
        $('header').stop().removeClass('mobile-header');
        $('body').stop().removeClass('unscroll');
        $('.menu-trigger').stop().removeClass('triggered');
        $('.site-menu-area').stop().removeAttr( 'style' );
    }
} );
    
    
} ) ( jQuery )